var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-img",attrs:{"id":"customButton"}},[_c('vs-button',{staticStyle:{"width":"100%"},attrs:{"id":"texthover","color":_vm.Color,"type":_vm.Type},on:{"click":function($event){return _vm.$emit('click')}}},[_c('h1',{staticStyle:{"color":"white"},attrs:{"id":""}},[_vm._v(_vm._s(_vm.$t(_vm.title)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }